import React from "react";
import { FaFacebookSquare, FaGithubSquare, FaLinkedin } from "react-icons/fa";
import logo from "../../Images/Gourob-2.png";

const Footer = () => {
    return (
        <footer className="footer footer-center p-10 bg-base-300 text-yellow-50 rounded mt-auto">
            <img src={logo} className="w-24" alt="" />
            <div className="flex flex-row gap-4">
                <a
                    href="https://github.com/GourobSaha"
                    target="_blank"
                    className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                    rel="noopener noreferrer"
                >
                    <FaGithubSquare />
                </a>
                <a
                    href="https://www.linkedin.com/in/gourob-saha-surjo-632751200/"
                    target="_blank"
                    className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                    rel="noopener noreferrer"
                >
                    <FaLinkedin />
                </a>
                <a
                    href="https://www.facebook.com/surjo.saha.547/"
                    target="_blank"
                    className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                    rel="noopener noreferrer"
                >
                    <FaFacebookSquare />
                </a>
            </div>
            <div>
                <p className="opacity-50">
                    Copyright © 2024 | Gourob Saha Surjo
                </p>
            </div>
        </footer>
    );
};

export default Footer;
